module.exports = __webpack_public_path__ + "fonts/050b1948-f226-4d20-a65a-15d8ed031222.6aa6e18.woff";